import { useNetwork } from "@mantine/hooks";

import { NetworkNotification } from "@components/NetworkNotification";
import { ScrollArea } from "@components/ScrollArea";
import { Sidebar } from "@components/Sidebar";

import { StyledWithSidebar } from "./WithSidebar.styled";


interface WithSidebarProps {
  children: React.ReactNode;
  hasBackground?: boolean;
  hasPatientNavbar?: boolean;
  hasDashboardNavbar?: boolean; // todo: Rename this to hasOtherNavbar or something similar
}

export const WithSidebar = ({
  children,
  hasBackground = true,
  hasPatientNavbar = false,
  hasDashboardNavbar = false,
}: WithSidebarProps) => {
  const { online } = useNetwork();

  return (
    <>
      <Sidebar />
      <StyledWithSidebar
        className={`${hasPatientNavbar ? "has-patient-navbar" : ""} ${
          hasDashboardNavbar ? "has-dashboard-navbar" : ""
        }`}>
        <NetworkNotification />

        {!hasPatientNavbar && !hasDashboardNavbar ? (
          <div
            className={`scroll-area-wrapper ${
              !online ? "show-notification" : "hide-notification"
            }`}>
            <ScrollArea
              hasWhiteBackground={hasBackground}
              scrollbarOrientation="both">
              {children}
            </ScrollArea>
          </div>
        ) : (
          <ScrollArea
            hasWhiteBackground={hasBackground}
            scrollbarOrientation="both">
            {children}
          </ScrollArea>
        )}
      </StyledWithSidebar>
    </>
  );
};
